import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { logo } from "../../components/PDF/utility";
import QRCode from "qrcode";
import { url } from './apiService';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

function fetchImageAsBase64(url) {
  return fetch(url)
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result.split(",")[1]);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
}

export async function generateEtdFormBillPDF(formData) {
  const attachmentInfo = formData?.AttachmentInfo || {};
  const personalInfo = formData?.PersonalInfo?.[0] || {};
  const applicationInfo = formData?.ApplicationInfo?.[0] || {};
  const travelInfo = formData?.TravelInfo?.[0] || {};
  const addressInfo = formData?.AddressInfo?.[0] || {};
  const parentInfo = formData?.ParentInfo?.[0] || {};
  const emergencyPerson = formData?.ContactEmergency?.[0] || {};

  try {
    let attachmentBase64 = null;
    if (attachmentInfo[0]?.AttachmentPath) {
      const imageUrl = `${url}get_file?path=${attachmentInfo[0]?.AttachmentPath}`;
      attachmentBase64 = await fetchImageAsBase64(imageUrl);
    }

    const tableLayout = {
      hLineWidth: function () {
        return 0.2;
      },
      vLineWidth: function () {
        return 0.2;
      },
      hLineColor: function () {
        // return "#e0e0e0";
        return "#bebebe";
      },
      vLineColor: function () {
        return "#bebebe";
      },
      paddingLeft: function () {
        return 4;
      },
      paddingRight: function () {
        return 4;
      },
      paddingTop: function () {
        return 4;
      },
      paddingBottom: function () {
        return 4;
      },
    };

    const qrCodeDataUrl = await QRCode.toDataURL(applicationInfo?.ApplicationID);

    const documentDefinition = {
      content: [
        {
          columns: [
            {
              image: qrCodeDataUrl,
              width: 100,
              height: 100,
              alignment: "left",
              margin: [-8, 0, 0, -15],
            },

            {
              text: `${applicationInfo?.ApplicationID?.toUpperCase() || ''}`, 
              bold: true,
              fontSize: 9,
              lineHeight: 1.5,
              alignment: "left",
              margin: [-95, 89, 0, -6],
            },
            
            {
              image: "data:image/jpeg;base64," + logo,
              width: 65,
              height: 65,
              alignment: "center",
              margin: [-60, 0, 35, 0],
            },
            {
              text: "Fomu CT 5(Ai) \n (Revised 2018) \n ",
              fontSize: 9,
              lineHeight: 1.5,
              alignment: "right",
              margin: [100, 0, 0, 0],
            },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          columns: [
            {
              width: 10,
              text: "",
            },
            {
              text: [
                {
                  text: "JAMHURI YA MUUNGANO WA TANZANIA \n OMBI LA HATI YA DHARURA",
                  style: "title",
                  fontSize: 12,
                },
              ],
              alignment: "center",
            },
            {
              width: 10,
              text: "",
            },
          ],
          margin: [0, -35, 0, 10],
        },
        {
          columns: [
            attachmentBase64
              ? {
                  image: `data:image/jpeg;base64,${attachmentBase64}`,
                  width: 83,
                  height: 95,
                  alignment: "right",
                  margin: [230, -85, -220, -15],
                }
              : {
                  text: "No image available",
                  fontSize: 10,
                  italics: true,
                  color: "red",
                  alignment: "center",
                  margin: [0, 10, 0, 0],
                },
          ],
          margin: [222, 0, -222, 10],
        },


        {
          stack: [
            {
              text: [
                {
                  text: "KWA MATUMIZI YA OFISI TU:",
                  style: "title",
                  fontSize: 11,
                },
              ],
              margin: [-180, -1, 180, 0],
            },
            {
              table: {
                widths: ["*", "*"],
                body: [
                  [
                    { text: "Jarada Na.", style: "tableContent" },
                    { text: "Tarehe:", style: "tableContent" },
                  ],
                  [
                    {
                      text: "Jina la Afisa aliyepokea Ombi:",
                      style: "tableContent",
                      colSpan: 2,
                    },
                    {},
                  ],
                  [
                    { text: "Cheo:", style: "tableContent" },
                    { text: "Sahihi:", style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
            },

            {
              text: [
                {
                  text: "Tafadhali sana kabla ya kujaza fomu hii, tembelea tovuti yetu, www.immigration.go.tz kisha soma maelezo muhimu kuhusu maombi ya pasipoti na vielezo unavyopaswa kuambatisha.",
                  style: "title",
                  fontSize: 9,
                  alignment: "justify",
                },
              ],
              margin: [0, 7, 0, 0],
            },

            {
              text: [
                {
                  text: "1. HABARI BINAFSI:",
                  style: "title",
                  fontSize: 11,
                },
              ],
              margin: [-205, 15, 205, 0],
            },

            {
              table: {
                widths: ["15%", "35%", "20%", "30%"],
                body: [
                  [
                    { text: "Jina la Ukoo:", style: "tableContent" },
                    { text: personalInfo?.FamilyName?.toUpperCase() || '', style: "tableContent" },
                    { text: "Jina la Kwanza:", style: "tableContent" },
                    { text: personalInfo?.FirstName?.toUpperCase() || '', style: "tableContent" },
                  ],                  
                  [
                    { text: "Jina la Kati:", style: "tableContent" },
                    { text: personalInfo?.MiddleName?.toUpperCase() || '', style: "tableContent", colSpan: 3 },
                    {},
                    {},
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["20%", "*"],
                body: [
                  [
                    { text: "Tarehe ya Kuzaliwa:", style: "tableContent" },
                    { text: personalInfo?.ApplicantDoB?.toUpperCase() || '', style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["15%", "35%", "20%", "30%"],
                body: [
                  [
                    {
                      text: "Mahali pa Kuzaliwa:",
                      style: "tableContent",
                      colSpan: 4,
                    },
                    {},
                    {},
                    {},
                  ],
                  [
                    { text: "Kijiji/Mtaa:", style: "tableContent" },
                    { text: personalInfo?.BirthVillage?.toUpperCase() || '', style: "tableContent" },
                    { text: "Kata/Shehia:", style: "tableContent" },
                    { text: personalInfo?.WardName?.toUpperCase() || '', style: "tableContent" },
                  ],
                  [
                    { text: "Wilaya:", style: "tableContent" },
                    { text: personalInfo?.DistrictName?.toUpperCase() || '', style: "tableContent" },
                    { text: "Mkoa:", style: "tableContent" },
                    { text: personalInfo?.RegionName?.toUpperCase() || '', style: "tableContent" },
                  ],
                  [
                    { text: "Nchi:", style: "tableContent" },
                    { text: personalInfo?.CountryName?.toUpperCase() || '', style: "tableContent", colSpan: 3 },
                    {},
                    {},
                  ],                  
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["25%", "25%", "25%", "25%"],
                body: [
                  [
                    {
                      text: "Raia wa Kujiandikisha:",
                      style: "tableContent",
                      colSpan: 4,
                    },

                    {},
                    {},
                    {},
                  ],
                  [
                    { text: "Shahada Na.", style: "tableContent" },
                    { text: "", style: "tableContent" },
                    { text: "Mahali Ilipotolewa:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                  ],
                  [
                    { text: "Tarehe ya Kujiandikisha:", style: "tableContent" },
                    { text: "", style: "tableContent", colSpan: 3 },
                    {},
                    {},
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["15%", "*"],
                body: [
                  [
                    { text: "Jinsi:", style: "tableContent" },
                    { text: personalInfo?.GenderName?.toUpperCase() || '', style: "tableContent" },
                  ],                  
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["15%", "*"],
                body: [
                  [
                    { text: "Kazi:", style: "tableContent" },
                    { text: travelInfo?.Occupation?.toUpperCase() || '', style: "tableContent" },
                  ],                  
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["20%", "*"],
                body: [
                  [
                    { text: "Habari ya Ndoa:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["15%", "*"],
                body: [
                  [
                    { text: "Jina la Zamani:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["20%", "30%", "20%", "30%"],
                body: [
                  [
                    { text: "Anwani ya Posta:", style: "tableContent" },
                    { text: addressInfo?.PostalAddress?.toUpperCase() || '', style: "tableContent" },
                    { text: "Simu:", style: "tableContent" },
                    { text: addressInfo?.PhoneNumber?.toUpperCase() || '', style: "tableContent" },
                  ],
                  [
                    { text: "Barua Pepe:", style: "tableContent" },
                    { text: addressInfo?.Email?.toUpperCase() || '', style: "tableContent" },
                    { text: "Faksi:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                  ],                  
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["15%", "35%", "17%", "33%"],
                body: [
                  [
                    {
                      text: "Anuani ya Makazi:",
                      style: "tableContent",
                      colSpan: 4,
                    },
                    {},
                    {},
                    {},
                  ],
                  [
                    { text: "Kijiji/Mtaa:", style: "tableContent" },
                    { text: addressInfo?.VillageName?.toUpperCase() || '', style: "tableContent" },
                    { text: "Nyumba Na.", style: "tableContent" },
                    { text: addressInfo?.HouseNumber?.toUpperCase() || '', style: "tableContent" },
                  ],
                  [
                    { text: "Kata/Shehia:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                    { text: "Wilaya:", style: "tableContent" },
                    { text: addressInfo?.DistrictName?.toUpperCase() || '', style: "tableContent" },
                  ],
                  [
                    { text: "Mkoa:", style: "tableContent" },
                    { text: addressInfo?.RegionName?.toUpperCase() || '', style: "tableContent", colSpan: 3 },
                    { text: "Nchi:", style: "tableContent" },
                    { text: addressInfo?.CountryName?.toUpperCase() || '', style: "tableContent", colSpan: 3 },
                  ],                  
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              text: [
                {
                  text: "2. MADHUMUNI YA SAFARI:",
                  style: "title",
                  fontSize: 11,
                },
              ],
              margin: [-185, 10, 185, 0],
            },
            {
              table: {
                widths: ["19%", "23%", "19%", "39%"],
                body: [
                  [
                    { text: "Dhumuni la Safari:", style: "tableContent" },
                    { text: travelInfo?.Purpose?.toUpperCase() || '', style: "tableContent" },
                    { text: "Nchi Unayokwenda:", style: "tableContent" },
                    { text: travelInfo?.Country?.toUpperCase() || '', style: "tableContent" },
                  ],                  
                ],
              },
              layout: tableLayout,
              margin: [0, 6, 0, 6],
            },            
            {
              text: [
                {
                  text: "Page 1 of 2",
                  style: "title",
                  fontSize: 7,
                  alignment: "right",
                },
              ],
              margin: [0, 0, 0, 0],
            },  
            
            
            //-------------------------------------------------------------------------------------------page2
            

            {
              text: [
                {
                  text: "3. HABARI ZA WAZAZI:",
                  style: "title",
                  fontSize: 11,
                },
              ],
              margin: [-195, -5, 195, 0],
            },

            {
              table: {
                widths: ["33%", "*"],
                body: [
                  [
                    {
                      text: "Jina kamili la Baba wa Mwombaji",
                      style: "tableContent",
                    },
                    { text: parentInfo?.FatherFullName, style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["20%", "30%", "20%", "30%"],
                body: [
                  [
                    {
                      text: "Mahali pa Kuzaliwa:",
                      style: "tableContent",
                      colSpan: 4,
                    },
                    {},
                    {},
                    {},
                  ],
                  [
                    { text: "Kijiji/Mtaa:", style: "tableContent" },
                    { text: parentInfo?.FatherVillage, style: "tableContent" },
                    { text: "Kata/Shehia:", style: "tableContent" },
                    { text: parentInfo?.FatherWardName, style: "tableContent" },
                  ],
                  [
                    { text: "Wilaya", style: "tableContent" },
                    { text: parentInfo?.FatherDistrictName, style: "tableContent" },
                    { text: "Mkoa:", style: "tableContent" },
                    { text: parentInfo?.FatherRegionName, style: "tableContent" },
                  ],
                  [
                    { text: "Nchi:", style: "tableContent" },
                    { text: parentInfo?.FatherCountryName, style: "tableContent" },
                    { text: "Tarehe ya Kuzaliwa:", style: "tableContent" },
                    { text: parentInfo?.FatherDOB, style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["10%", "20%", "20%", "20%", "10%", "20%"],
                body: [
                  [
                    {
                      text: "Shahada ya Kujiandikisha Uraia:",
                      style: "tableContent",
                      colSpan: 6,
                    },
                    {},
                    {},
                    {},
                    {},
                    {},
                  ],
                  [
                    { text: "Namba:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                    { text: "Mahali Ilipotolewa:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                    { text: "Tarehe:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["33%", "*"],
                body: [
                  [
                    {
                      text: "Jina kamili la Mama wa Mwombaji",
                      style: "tableContent",
                    },
                    { text: parentInfo?.MotherFullName, style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["20%", "30%", "20%", "30%"],
                body: [
                  [
                    {
                      text: "Mahali pa Kuzaliwa:",
                      style: "tableContent",
                      colSpan: 4,
                    },
                    {},
                    {},
                    {},
                  ],
                  [
                    { text: "Kijiji/Mtaa:", style: "tableContent" },
                    { text: parentInfo?.MotherVillage, style: "tableContent" },
                    { text: "Kata/Shehia:", style: "tableContent" },
                    { text: parentInfo?.MotherWardName, style: "tableContent" },
                  ],
                  [
                    { text: "Wilaya", style: "tableContent" },
                    { text: parentInfo?.MotherDistrictName, style: "tableContent" },
                    { text: "Mkoa:", style: "tableContent" },
                    { text: parentInfo?.MotherRegionName, style: "tableContent" },
                  ],
                  [
                    { text: "Nchi:", style: "tableContent" },
                    { text: parentInfo?.MotherCountryName, style: "tableContent" },
                    { text: "Tarehe ya Kuzaliwa:", style: "tableContent" },
                    { text: parentInfo?.MotherDOB, style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              table: {
                widths: ["10%", "20%", "20%", "20%", "10%", "20%"],
                body: [
                  [
                    {
                      text: "Shahada ya Kujiandikisha Uraia:",
                      style: "tableContent",
                      colSpan: 6,
                    },
                    {},
                    {},
                    {},
                    {},
                    {},
                  ],
                  [
                    { text: "Namba:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                    { text: "Mahali Ilipotolewa:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                    { text: "Tarehe:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },          
            {
              text: [
                {
                  text: "4. KUTOA TAARIFA WAKATI WA DHARURA:",
                  style: "title",
                  fontSize: 11,
                },
              ],
              margin: [-145, 5, 145, 0],
            },

            {
              text: [
                {
                  text: "Ndugu/Rafiki/watakaopewa taarifa wakati wa dharura (Ajali au Kifo)",
                  style: "title",
                  fontSize: 9,
                },
              ],
              margin: [-115, 0, 115, 0],
            },

            {
              table: {
                widths: ["15%", "35%", "15%", "35%"],
                body: [
                  [
                    { text: "Jina Kamili:", style: "tableContent" },
                    { text: emergencyPerson?.E1FullName, style: "tableContent" },
                    { text: "Jina Kamili:", style: "tableContent" },
                    { text: emergencyPerson?.E2FullName, style: "tableContent" },
                  ],
                  [
                    { text: "Simu:", style: "tableContent" },
                    { text: emergencyPerson?.E1PhoneNumber, style: "tableContent" },
                    { text: "Simu:", style: "tableContent" },
                    { text: emergencyPerson?.E2PhoneNumber, style: "tableContent" },
                  ],
                  [
                    { text: "Anapoishi:", style: "tableContent" },
                    { text: emergencyPerson?.E1Street, style: "tableContent" },
                    { text: "Anapoishi:", style: "tableContent" },
                    { text: emergencyPerson?.E2Street, style: "tableContent" },
                  ],
                  [
                    { text: "Uhusiano:", style: "tableContent" },
                    { text: emergencyPerson?.E1RelationShip, style: "tableContent" },
                    { text: "Uhusiano:", style: "tableContent" },
                    { text: emergencyPerson?.E2RelationShip, style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              text: [
                {
                  text: "5. WAOMBAJI WALIOCHINI YA MIAKA 18",
                  style: "title",
                  fontSize: 11,
                },
              ],
              margin: [-150, 5, 150, 0],
            },

            {
              text: [
                {
                  text: "Waombaji waliochini ya miaka 18 maombi yao lazima yaidhinishwe na Mzazi/Mlezi",
                  style: "title",
                  fontSize: 9,
                },
              ],
              margin: [-85, 0, 85, 0],
            },

            {
              table: {
                widths: ["20%", "30%", "20%", "30%"],
                body: [
                  [
                    {
                      text: "Jina Kamili:",
                      style: "tableContent",
                    },
                    { text: "", style: "tableContent", colSpan: 3 },
                    {},
                    {},
                  ],
                  [
                    { text: "Kazi:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                    { text: "Simu:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                  ],
                  [
                    { text: "Anuani", style: "tableContent" },
                    { text: "", style: "tableContent" },
                    { text: "Uhusiano:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                  ],
                  [
                    {
                      text: "Tamko: Nashuhudia kwamba mwombaji ni mtoto wangu wa (kumzaa / kumlea) pia naruhusu apewe ETD kwa ajili ya safari",
                      style: "tableContent",                      
                      fontSize: 9,
                      colSpan: 4,
                    },
                    {},
                    {},
                    {},
                  ],
                  [
                    { text: "Sahihi", style: "tableContent" },
                    { text: "", style: "tableContent" },
                    { text: "Tarehe:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              text: [
                {
                  text: "TAMKO RASMI",
                  style: "title",
                  fontSize: 11,
                },
              ],
              margin: [-215, 5, 215, 0],
            },

            {
              text: [
                {
                  text: "Mimi niliyetia saini hapa chini, ninakiri ya kwamba habari zote nilizotajwa katika fomu hii kadiri nijuavyo na kuamini ni za kweli, kweli tupu. Naomba kupewa hati ya dharura ya kusafiria kwa madhumuni hayo niliyoeleza hapo juu, na pia",
                  style: "title",
                  fontSize: 9,
                  alignment: "justify",
                },
              ],
              margin: [5, 0, -5, 0],
            },

            {
              table: {
                widths: ["20%", "30%", "20%", "30%"],
                body: [
                  [
                    {
                      text: "Jina Kamili:",
                      style: "tableContent",
                    },
                    { text: "", style: "tableContent", colSpan: 3 },
                    {},
                    {},
                  ],
                  [
                    { text: "Sahihi:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                    { text: "Tarehe:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 5],
            },

            {
              text: [
                {
                  text: "6. HATUA ZILIZOCHUKULIWA NA AFISA MHIDHINISHI - (KWA MATUMIZI YA OFISI TU:)",
                  style: "title",
                  alignment: "left",
                  fontSize: 11,
                },
              ],
              margin: [2, 5, -2, 0],
            },

            {
              table: {
                widths: ["27%", "23%", "20%", "30%"],
                body: [
                  [
                    {
                      text: "",
                      style: "tableContent",
                      colSpan: 4,
                      margin: [0, 20, 0, 2],
                    },
                    {},
                    {},
                    {},
                  ],
                  [
                    {
                      text: "Jina Kamili:",
                      style: "tableContent",
                    },
                    { text: "", style: "tableContent", colSpan: 3 },
                    {},
                    {},
                  ],
                  [
                    {
                      text: "Sahihi ya Afisa wa Pasipoti:",
                      style: "tableContent",
                    },
                    { text: "", style: "tableContent" },
                    { text: "Tarehe:", style: "tableContent" },
                    { text: "", style: "tableContent" },
                  ],
                ],
              },
              layout: tableLayout,
              margin: [0, 0, 0, 13],
            },
            {
              text: [
                {
                  text: "Page 2 of 2",
                  style: "title",
                  fontSize: 7,
                  alignment: "right",
                },
              ],
              margin: [0, 0, 0, 0],
            },

          ],
          margin: [5, -2, 0, 0],
        },


      ],

      styles: {
        header: {
          fontSize: 18,
          bold: true,
          alignment: "center",
          margin: [0, 10, 0, 10],
        },
        title: {
          fontSize: 12,
          bold: true,
          alignment: "center",
        },
      },
      defaultStyle: {
        fontSize: 10,
      },
    };

    return new Promise((resolve, reject) => {
      pdfMake.createPdf(documentDefinition).getBase64((encodedString) => {
        if (encodedString) {
          resolve(encodedString);
        } else {
          reject("Failed to generate PDF");
        }
      });
    });
  } catch (error) {
    console.error("Error fetching image:", error);
    throw new Error("Failed to fetch image");
  }
}
